import React from "react";
import { Link } from "react-router-dom";
import { Search, Radio, Dropdown } from "semantic-ui-react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
const ShipmentHeader = (props) => {
  const { t } = props;
  return (
    <React.Fragment>
      <div id="dispatch_bar">
        <div className="container-fluid dip_bar">
          <div className="row">
            <div className="col-sm-12">
              <div className="d-flex justify-content-between">
                <label className="mt-2 font-weight-normal">{props.title}</label>
                <div className="form-inline">
                  {/* <span>{this.state.path}</span> */}
                  <Dropdown
                  name="movement_type"
                  clearable
                  className="mr-1"
                  style={{ width: "100%", fontWeight: "normal" }}
                  // disabled={disable}
                  selection
                  placeholder={
                    t("shipment_form.movement_type.placeholder") ||
                    "Movement Type"
                  }
                  // onChange={(name, data) => checkForOrder(name, data)}
                  options={[
                    { key: "2", text: "Import", value: "import" },
                    { key: "3", text: "Primary", value: "primary" },
                  ]}
                  // value={values.movement_type}
                />
                  <Radio
                    toggle
                    className="mr-1"
                    name="gridView"
                    checked={props.toggle}
                    onChange={props.toggleView}
                    hidden={props.hidden}
                  />
                  <Search
                    size="mini"
                    className="mr-1 ml-1"
                    onKeyUp={props.handleSearch}
                    input={{ icon: "search", iconPosition: "left" }}
                    placeholder={t("action_button.search") || "Search"}
                  />
                  {/* <button
                    type="button"
                    data-toggle="modal"
                    data-target="#ImportXL"
                    hidden={props.hidden}
                    className="w3-button w3-small w3-border w3-hover-border-black w3-hover-white w3-border-light-grey ml-1 w3-round"
                  >
                    <img
                      src="assets/svg/import.svg"
                      alt=""
                      style={{ width: "12px" }}
                    />
                    {t("action_button.import") || "Import"}
                  </button> */}
                  {props.permissions.TA_SHIPMENT.CREATE == true ? (
                    <Link
                      to={props.LinkName}
                      className="ui basic button mini"
                    >
                      <i className="fas fa-plus"></i>{" "}
                      {t("action_button.new") || "New"}
                    </Link>
                  ) : (
                      null
                    )}

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};
const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
}
export default connect(mapStateToProps)(translate("shipment")(ShipmentHeader));
